const getBackgroundColor = (colorMode: string): string => (colorMode === 'dark' ? '#121212' : '#f7f7f7');

export const getBorderColor = (colorMode) => '1px solid ' + (colorMode === 'dark' ? 'rgba(255, 255, 255, .15)' : '#e3e3e3');

export default getBackgroundColor;
